export default "__VITE_ASSET__fdf2f968__"